import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-internal-server-error',
    templateUrl: './internal-server-error.component.html',
    styleUrls: ['./internal-server-error.component.scss'],
})
export class InternalServerErrorComponent {
    constructor(private route: ActivatedRoute) {
    }

    ngOnInit() {
        const url = this.route.snapshot.paramMap.get('url');
    }
}
